<!-- eslint-disable -->
<template lang="pug">
    div
        olympiad-form(v-if="isShowForm" :id="olympiadId" :isCopy="isCopy")
            template(slot="title") {{ $i18n.t('olympiads.olympiads_create_createOlympiad') }}
            template(slot="button") {{ $i18n.t('olympiads.olympiads_olympiadForm_publish') }}
        div(v-else) {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
</template>

<script>
    /*eslint-disable*/
    import BoxHeader from '../../elements/BoxHeader.vue';
    import OlympiadForm from './OlympiadForm.vue';
    import {mapState} from 'vuex';

    export default {
		props: {
			olympiadId: [Number, String, undefined]
		},
        beforeRouteLeave(to, from, next) {
            if (to.name !== 'olympiad-level:create') {
                this.$store.dispatch('setOlympiad', null)
            }
            next()
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            isShowForm () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
			isCopy () {
				return !!this.olympiadId
			}
        },
        components: {
            BoxHeader,
            OlympiadForm
        }
    }
</script>
